module.exports = __webpack_public_path__ + "h5/img/record3.366fe877.png";